module.exports = __webpack_public_path__ + "static/img/alibaba.b6c1a236.png";